import { useTranslation } from "react-i18next";
import { TherapyTool } from "../../domain/types";

/**
 * The chips under a catalogue entry.
 *
 * Categories come first because they say what kind of tool it is; therapy
 * types, when present, say which ways of working it suits.
 */
export default function ToolLabels({ tool }: { tool: TherapyTool }) {
    const { t } = useTranslation();
    const categories = tool.categories ?? [];

    if (categories.length === 0 && tool.therapy_types.length === 0) return null;

    return (
        <div className="mt-3 flex flex-wrap gap-1.5">
            {categories.map((category) => (
                <span
                    key={category}
                    className="rounded-md bg-brand-50 px-2 py-1 text-xs text-brand-600 dark:bg-brand-500/10 dark:text-brand-400"
                >
                    {t(`marketplace.categories.${category}`)}
                </span>
            ))}
            {tool.therapy_types.map((type) => (
                <span
                    key={type}
                    className="rounded-md bg-gray-100 px-2 py-1 text-xs text-gray-600 dark:bg-white/5 dark:text-gray-400"
                >
                    {t(`session.therapyOptions.${type}`)}
                </span>
            ))}
        </div>
    );
}
